export const GENDERS = [
  { name: "Male", code: "M" },
  { name: "Female", code: "F" },
  { name: "NA", code: "N" },
];
